
import React from "react";

interface MenuItemProps {
  navbarOnly?: boolean;
  onMenuSelect?: (menuKey: string) => void;
}

const MenuItems: React.FC<MenuItemProps> = ({ navbarOnly, onMenuSelect }) => {
  const backendResponse = localStorage.getItem("backendResponse");

  if (!backendResponse) return <p>No data found</p>;

  const parsed = JSON.parse(backendResponse);

  // Correct source
  const appMenus = parsed.objectData?.appConfig?.appMenus;

  if (!appMenus) return <p>No menu items available</p>;

  // Parse JSON string
  let menuConfig: any = {};
  try {
    menuConfig =
      typeof appMenus === "string"
        ? JSON.parse(appMenus)
        : appMenus;
    //  menuConfig.knowledgebase = true;
  } catch (err) {
    console.error("Invalid appMenus JSON", err);
    menuConfig = {};
  }
  // const NAVBAR_MENU_LABELS = [
  //   "remarks",
  //   "knowledgebase",
  //   "hostel",
  //   "feedback",
  //   "classroom"
  // ];

  // Convert object → array
  const items = Object.entries(menuConfig)
    .filter(([_, enabled]) => enabled === true)
    .map(([key]) => ({
      key,
      // label: keys
      label: key.replace(/([A-Z])/g, " $1")
    }))
    .filter((item: any) => item.key?.toLowerCase() !== "schoolcircle")
  // .filter(() => navbarOnly);
  const menuGroups = [
    {
      title: "Campus Updates",
      icon: "fa-bell",
      className: "campus-card",
      menus: ["notifications", "classRoom"]
    },
    {
      title: "Diary",
      icon: "fa-book",
      className: "diary-card",
      menus: ["studentDiary"]
    },
    {
      title: "Tasks & Exams",
      icon: "fa-clipboard-check",
      className: "exam-card",
      menus: ["assignments", "onlineTests"]
    },
    {
      title: "Connect",
      icon: "fa-users",
      className: "connect-card",
      menus: ["ptms", "serviceRequests"]
    },
    {
      title: "Academics",
      icon: "fa-graduation-cap",
      className: "academics-card",
      menus: ["exams", "assessments", "knowledgebase"]
    },
    {
      title: "Student Pulse",
      icon: "fa-chart-line",
      className: "pulse-card",
      menus: ["attendance", "remarks", "feedback"]
    },
    {
      title: "Schedules",
      icon: "fa-calendar-days",
      className: "schedule-card",
      menus: ["circulars", "timetable"]
    },
    {
      title: "Facilities",
      icon: "fa-school",
      className: "facility-card",
      menus: ["transport", "hostel"]
    },
    {
      title: "Financial Desk",
      icon: "fa-wallet",
      className: "finance-card",
      menus: ["finance"]
    },
    {
      title: "Academics & Services",
      icon: "fa-graduation-cap",
      className: "academics-card",
      menus: ["otherassessment"]
    },
    {
      title: "Learning",
      icon: "fa-lightbulb",
      className: "learning-card",
      menus: ["liveClasses"]
    },
    {
      title: "Events & Gallery",
      icon: "fa-images",
      className: "events-card",
      menus: ["events", "gallery", "calendar"]
    },
  ];
  // .filter((item: any) =>
  //   navbarOnly
  //     ? NAVBAR_MENU_LABELS.includes(item.key.toLowerCase())
  //     : !NAVBAR_MENU_LABELS.includes(item.key.toLowerCase())
  // );

  if (items.length === 0) return <p>No menu items available</p>;

  const toCamelCase = (text: string) => {
    const key = text.toLowerCase();
    if (key === "ptms") return "PTM's";
    if (key === "otherassessment") return "Other Assessment";
    return text
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  // return (
  //   <ul className={`menu-list-scroll ${navbarOnly ? "navbar-menu" : ""}`}>
  //     {items.map((item: any) => (
  //       <li
  //         key={item.key}
  //         className={`nav-item menu-item ${navbarOnly ? "navbar-item" : ""}`}
  //         onClick={() => onMenuSelect && onMenuSelect(item.key)}
  //       >
  //         <span className="menu-label nav-item">
  //           {/* {navbarOnly ? `❖ ${item.label}` : item.label} */}
  //           {navbarOnly ? `❖ ${toCamelCase(item.label)}` : toCamelCase(item.label)}
  //         </span>
  //       </li>
  //     ))}
  //   </ul>
  // );
  return (
    <div className="dashboard-sections">
      {menuGroups.map((group) => {
        const groupMenus = items.filter((item: any) =>
          group.menus.includes(item.key)
        );
        return (
          <div className={`dashboard-card ${group.className || ""}`} key={group.title}>
            {/* <h3>{group.title}</h3> */}
            <i className={`fas ${group.icon}`}></i>&nbsp;&nbsp;{group.title}
            {/* <div className="dashboard-buttons"> */}
            {groupMenus.map((item: any) => (
              <div
                key={item.key}
                className={`nav-item menu-item ${navbarOnly ? "navbar-item" : ""}`}
                onClick={() => onMenuSelect?.(item.key)}
              >
                <ul><li>
                  <span>{toCamelCase(item.label)}</span></li></ul>
              </div>
            ))}
            {/* </div> */}
          </div>
        );
      })}
    </div>
  );
};

export default MenuItems;
